// Të dhëna mock për Bali Funeral Home (ndarja UI/backend)
import {
  Plane,
  Flower2,
  FileText,
  HeartHandshake,
  Clock,
  ShieldCheck,
  Church,
  Box,
  Landmark,
} from "lucide-react";

export const brand = {
  name: "Bali Funeral Home",
  short: "Bali Funeral Home",
  tagline: "Pranë jush me dinjitet dhe respekt në momentet më të vështira",
  founded: "2005",
  whatsapp: "355695730444",
  phoneDisplay: "+355 695 730 444",
  phoneItaly: "393495630048",
  phoneItalyDisplay: "+39 349 563 0048",
  email: "funeralbali@hotmail.com",
  address: "Peqin, Shqipëri",
  italyOffice: "Itali (seli operative aktive)",
  logo: "/images/logo.jpeg",
};

export const navLinks = [
  { label: "Kryefaqe", href: "#home" },
  { label: "Shërbimet", href: "#servizi" },
  { label: "Transporti", href: "#transport" },
  { label: "Produktet", href: "#produkte" },
  { label: "Rreth Nesh", href: "#chi-siamo" },
  { label: "Kontakt", href: "#contatti" },
];

export const services = [
  {
    id: "trasporto",
    icon: Plane,
    title: "Transport Ndërkombëtar",
    description:
      "Shërbim i specializuar i riatdhesimit dhe transportit funebër ndërkombëtar, me kujdes për çdo detaj logjistik dhe dokumentar.",
  },
  {
    id: "cerimonie",
    icon: Church,
    title: "Ceremoni Funebre",
    description:
      "Organizim i plotë i ceremonive civile dhe fetare, në respekt të plotë të vullnetit dhe traditave të familjes.",
  },
  {
    id: "pratiche",
    icon: FileText,
    title: "Kryerja e Praktikave",
    description:
      "Menaxhim i plotë i të gjithë dokumentacionit dhe praktikave administrative të nevojshme, në Shqipëri dhe jashtë saj.",
  },
  {
    id: "rimpatrio",
    icon: HeartHandshake,
    title: "Asistencë dhe Riatdhesim",
    description:
      "Shoqërim dhe mbështetje e vazhdueshme për familjet, me një shërbim riatdhesimi të sigurt, diskret dhe dinjitoz.",
  },
];

export const values = [
  {
    icon: Clock,
    title: "Në dispozicion 24/7",
    description:
      "Jemi të arritshëm në çdo moment, çdo ditë të vitit, për t'iu përgjigjur menjëherë çdo nevoje.",
  },
  {
    icon: ShieldCheck,
    title: "Diskrecion dhe Respekt",
    description:
      "Çdo shërbim kryhet me diskrecionin, ndjeshmërinë dhe kujdesin maksimal ndaj familjes.",
  },
  {
    icon: Flower2,
    title: "Kujdes në çdo detaj",
    description:
      "Lule, dekorime dhe ceremoni të kuruara me elegancë për të nderuar sa më mirë kujtimin e të dashurve tuaj.",
  },
];

export const about = {
  overline: "Rreth Nesh",
  title: "Një udhërrëfyes diskret në momentet më delikate",
  paragraphs: [
    "Prej vitit 2005, Bali Funeral Home ofron shërbime funerale profesionale me përkushtim, kompetencë dhe respekt të thellë për familjet që asistojmë.",
    "Kujdesemi për transportin ndërkombëtar të të ndjerëve, organizimin e ceremonive dhe kryerjen e të gjitha praktikave të nevojshme, duke garantuar një mbështetje të vazhdueshme dhe diskrete.",
    "Angazhimi ynë është të lehtësojmë barrën e momenteve të vështira, duke shoqëruar çdo familje me humanizëm, dinjitet dhe kujdes në çdo detaj.",
    "Përveç selisë sonë në Shqipëri, kemi tashmë një seli operative aktive edhe në Itali, për t'i qëndruar pranë bashkësisë shqiptare kudo që ndodhet.",
  ],
  stats: [
    { value: "20+", label: "Vite eksperiencë" },
    { value: "24/7", label: "Asistencë e vazhdueshme" },
    { value: "100%", label: "Përkushtim dhe respekt" },
  ],
};

export const fullServices = [
  "Përgatitja dhe vendosja e trupit të të ndjerit",
  "Përgatitja e dhomës mortore",
  "Transport ndërkombëtar i trupit",
  "Procedura varrimi për Shqipërinë, Kosovën, Maqedoninë dhe Evropën",
  "Furnizim arkivolësh dhe mjete funerale",
  "Gurë varresh dhe monumente",
  "Pasaportë mortore (leje transporti mortor)",
  "Ceremoni funebre katolike, ortodokse dhe myslimane",
  "Nekrologji (njoftime mortore)",
  "Kremacione",
  "Ri-atdhesim i trupave nga e gjithë bota",
  "Përfundimi i procedurave burokratike pas vdekjes",
  "Kapela dhe varre familjare",
  "Ekzhumime dhe zhvarrime",
];

export const transport = {
  overline: "Transport Ndërkombëtar",
  title: "Transport Funebër Ndërkombëtar",
  subtitle:
    "Organizojmë riatdhesimin dhe transportin e të ndjerëve nga Italia drejt Ballkanit dhe të gjithë Evropës, duke u kujdesur për çdo procedurë dhe dokument.",
  image: "/images/transport.jpeg?v=5",
  vehicles: [
    { image: "/images/transport.jpeg?v=5", label: "Furgon transporti — Mercedes Vito" },
    { image: "/images/img4.jpeg", label: "Karro funebër për ceremoni" },
  ],
  routes: [
    {
      from: "Itali",
      to: "Shqipëri",
      description:
        "Shërbime funerale të plota Itali–Shqipëri, me transport të sigurt dhe të gjithë dokumentacionin e nevojshëm.",
    },
    {
      from: "Itali",
      to: "Kosovë",
      description:
        "Transport dhe riatdhesim Itali–Kosovë, me asistencë të plotë burokratike në të dyja vendet.",
    },
    {
      from: "Itali",
      to: "Maqedoni e Veriut",
      description:
        "Shërbime funerale Itali–Maqedoni e Veriut, me kujdes për çdo detaj logjistik dhe ligjor.",
    },
  ],
};

export const products = [
  {
    id: "florale",
    icon: Flower2,
    title: "Dekorime Florale",
    image: "/images/floral.jpeg?v=2",
    description:
      "Kurora, buqeta dhe dekorime me lule të freskëta, të përgatitura me shije e elegancë për të nderuar kujtimin.",
  },
  {
    id: "arkivole",
    icon: Box,
    title: "Arkivolë",
    image: "/images/casket.jpeg",
    description:
      "Gamë e gjerë arkivolësh klasikë dhe modernë, nga druri fisnik deri te modelet e personalizuara.",
  },
  {
    id: "monumente",
    icon: Landmark,
    title: "Gurë Varresh & Monumente",
    image: "/images/monument.png?v=5",
    description:
      "Gurë varresh dhe monumente prej mermeri e graniti, të punuar me mjeshtëri dhe kujdes në çdo detaj.",
  },
];

export const images = {
  hero: "/images/img1.jpeg",
  about: "/images/img2.jpeg",
  service1: "/images/img3.jpeg",
  service2: "/images/img4.jpeg",
  contact: "/images/img5.jpeg",
};
